// @ts-nocheck
import React from 'react';
import { Box, Container, Grid, Typography, Button, Link, keyframes } from '@mui/material';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import { motion } from 'framer-motion';
import ElhamAlasstaPdf from "../../src/static/ElhamAlassta.pdf";
import programming from "../static/images/programming.png";

// --- Keyframe Animation for SVG and Button ---
const floatAnimation = keyframes`
  0% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    /* transform: translateY(-10px) rotate(1deg); */
     transform: translateY(-15px) scale(1.02); 
  }
  100% {
    /* transform: translateY(0) rotate(0deg); */
      transform: translateY(0) scale(1);
  }
`;

const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
    /* box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.5); */
    box-shadow: 0 0 0 0 rgb(160, 184, 246);
  }
  50% {
    transform: scale(1.02);
    box-shadow: 0 0 0 10px rgba(16, 185, 129, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);
  }
`;

// Define animation variants for a staggered, smooth effect
const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.2, 
        },
    },
};

const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.8,
            ease: [0.42, 0, 0.58, 1],
        },
    },
};

const svgVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
        opacity: 1,
        scale: 1,
        transition: {
            duration: 1.5,
            ease: [0.42, 0, 0.58, 1],
        },
    },
};

export default function Resume() { 

    return (
        <Box className="resume-Section"
            sx={{
                py: { xs: 8, md: 12 },  
                backgroundColor: '#6b8ffc !important',
                color: 'white',
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                overflow: 'hidden',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%', 
                    backgroundColor: '#7c9af2 ',
                    zIndex: 0,
                    pointerEvents: 'none',
                },
            }}
        >
            <Container maxWidth="lg" sx={{ zIndex: 1 }}>
                <Grid
                    container
                    spacing={6}
                    alignItems="center"
                    justifyContent="center"
                    component={motion.div}
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.4 }}
                >
                    {/* Left-side content grid */}
                    <Grid size={6}>
                        <Box
                            component={motion.div}
                            variants={itemVariants}
                            sx={{
                                p: { xs: 3, md: 3 },
                            }}
                        >
                            <Typography variant="h5" component="h2" sx={{ color: '#FFF' }}>
                                Hello there, I'm
                            </Typography>
                            <Typography variant="h3" component="h1" gutterBottom
                                sx={{
                                    color: '#FFF',
                                    fontSize: { xs: '2.5rem', md: '3.5rem' },
                                    fontWeight: 700,
                                    textShadow: '0 0 10px rgb(178, 199, 248)',
                                }}
                            >
                                Elham Alassta
                            </Typography>
                            <Typography variant="body1" sx={{ mt: 2, mb: 4, lineHeight: 1.8, color: '#FFF' }}>
                                I'm a passionate **Full Stack Web Developer** with a focus on creating modern, scalable applications. My experience is centered around the **Laravel** and **React.js** ecosystems, building everything from robust APIs to dynamic user interfaces. I excel in collaborative environments and am a firm believer in continuous learning.
                            </Typography>

                            <Link
                                href={ElhamAlasstaPdf}
                                download
                                component={Button}
                                variant="contained" // Changed to contained for more visual weight
                                size="large" // Larger button
                                sx={{
                                    mt: 2,
                                    backgroundColor: '#1976d2 ', // Use a solid green color
                                    color: '#FFF',
                                    fontWeight: 600,
                                    px: 4,
                                    py: 1.5,
                                    transition: 'all 0.3s ease-in-out',
                                    animation: `${pulseAnimation} 2s infinite cubic-bezier(0.25, 0.46, 0.45, 0.94)`,
                                    '&:hover': {
                                        backgroundColor: '#b6cbf9  ',
                                        transform: 'translateY(-3px)',
                                        boxShadow: '0 6px 20px rgba(141, 197, 245, 0.6)',
                                    },
                                }}
                                startIcon={<FilePresentIcon />}
                            >
                                Download My Resume
                            </Link>
                        </Box>
                    </Grid>

                    {/* Right-side SVG illustration grid */}
                    <Grid size={6}>
                        <Box
                            component={motion.div}
                            variants={svgVariants} // You can reuse svgVariants or create new ones
                            sx={{
                                width: '100%',
                                height: { xs: '300px', md: '450px' },
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                p: { xs: 2, md: 4 },
                                // Apply the animation to the Box that contains the image
                                animation: `${floatAnimation} 4s ease-in-out infinite`,
                                '& img': { // Target the img element specifically if needed for finer control
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain', // Ensure the image scales correctly
                                    // You could also apply filter effects here, like drop-shadow
                                    filter: 'drop-shadow(0 10px 15px rgba(0,0,0,0.2))',
                                }
                            }}
                        >
                            <img width="100%" src={programming} alt="programming" height="100%" />


                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
}